// extracted by mini-css-extract-plugin
export default {"container":"TermsAndPrivacy_container__ZW160","section":"TermsAndPrivacy_section__U2HIf"};